import { Integration_Service_Names_Enum } from '@main/graphql/types.admin.generated';

import { IntegrationService } from '../../../../lib';
import { OneloginConnector } from '../../connector';

export const OneloginService = IntegrationService.make({
  connector: OneloginConnector,
  name: Integration_Service_Names_Enum.Onelogin,
});
